// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-logout-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 20;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7019607843);
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-logout-modal .modalLogout {
  background-color: var(--Foreground);
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  display: flex;
  gap: 1.25rem;
}
.confirm-logout-modal .modalLogout .darkmode {
  opacity: 0.5;
}
.confirm-logout-modal .modalLogout .lightMode {
  opacity: 1;
}
.confirm-logout-modal .modalLogout img {
  width: 13rem;
  height: 13rem;
}
.confirm-logout-modal .modalLogout .logoutCont {
  max-width: 25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  gap: 1.25rem;
}
.confirm-logout-modal .modalLogout .logoutCont h1 {
  font-size: 1.25rem;
  color: var(--TextColor);
  font-weight: 700;
}
.confirm-logout-modal .modalLogout .logoutCont p {
  font-size: 1rem;
  color: var(--TextColor);
  text-wrap: pretty;
  line-height: 1.25rem;
}
.confirm-logout-modal .modalLogout .logoutCont div {
  display: flex;
  gap: 0.6rem;
  align-items: center;
}
.confirm-logout-modal .modalLogout .logoutCont div button {
  width: 6rem;
  height: 2rem;
  border-radius: 0.3rem;
  border: 1px solid #B2B2B2;
  color: var(--TextColor);
  font-size: 0.875rem;
}
.confirm-logout-modal .modalLogout .logoutCont div button:nth-child(2) {
  background-color: var(--AccentColor);
  color: white;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/ConfirmLogoutModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACI;EACE,mCAAA;EACA,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;AACN;AAAM;EACE,YAAA;AAER;AAAM;EACE,UAAA;AAER;AAAM;EACE,YAAA;EACA,aAAA;AAER;AAAM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;AAER;AADQ;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AAGV;AADQ;EACE,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAGV;AADQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAGV;AAFU;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AAIZ;AAHY;EACE,oCAAA;EACA,YAAA;EACA,YAAA;AAKd","sourcesContent":[".confirm-logout-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  z-index: 20;\n  height: 100vh;\n  background: #000000b3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n    .modalLogout {\n      background-color: var(--Foreground);\n      padding: 1rem 1.25rem;\n      border-radius: 0.5rem;\n      display: flex;\n      gap: 1.25rem;\n      .darkmode{\n        opacity: .5;\n      }\n      .lightMode{\n        opacity: 1;\n      }\n      img{\n        width: 13rem;\n        height: 13rem;\n      }\n      .logoutCont{\n        max-width: 25rem;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-evenly;\n        gap: 1.25rem;\n        h1{\n          font-size: 1.25rem;\n          color: var(--TextColor);\n          font-weight: 700;\n        }\n        p{\n          font-size: 1rem;\n          color: var(--TextColor);\n          text-wrap: pretty;\n          line-height: 1.25rem;\n        }\n        div{\n          display: flex;\n          gap: .6rem;\n          align-items: center;\n          button{\n            width: 6rem;\n            height: 2rem;\n            border-radius: .3rem;\n            border: 1px solid #B2B2B2;\n            color: var(--TextColor);\n            font-size: 0.875rem;\n            &:nth-child(2){\n              background-color: var(--AccentColor);\n              color: white;\n              border: none;\n            }\n          }\n        }\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
